import {tabSelected} from "../@signals";
import {GLOBAL_EXECUTION_TABS} from "../@constants";
import {Grid} from "@mui/material";
import React from "react";
import GlobalExecutionsBatchTable from "./Table";
import GlobalBatchesSearchesModal from "./SearchesModal";

export default function GlobalExecutionBatchesBlock() {
    if (tabSelected.value !== GLOBAL_EXECUTION_TABS.BATCHES) return null

    return <>
        <Grid item xs={12}>
            <GlobalExecutionsBatchTable />
        </Grid>
        <Grid item>
            <GlobalBatchesSearchesModal/>
        </Grid>
    </>
}